import { render, staticRenderFns } from "./block-route-details.vue?vue&type=template&id=3a6d0129&scoped=true&lang=pug"
import script from "./block-route-details.vue?vue&type=script&lang=js"
export * from "./block-route-details.vue?vue&type=script&lang=js"
import style0 from "./block-route-details.vue?vue&type=style&index=0&id=3a6d0129&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a6d0129",
  null
  
)

export default component.exports